import firebase from 'firebase/app';
import 'firebase/firestore';
import "firebase/auth"
import "firebase/database"
import "firebase/storage"

const firebaseConfig = {
    apiKey: "AIzaSyBqp5hBUjQDt8pIK41RYk_EiKLf0yAM6oA",
    authDomain: "tokoakbar-18261.firebaseapp.com",
    databaseURL: "https://tokoakbar-18261-default-rtdb.asia-southeast1.firebasedatabase.app",
    projectId: "tokoakbar-18261",
    storageBucket: "tokoakbar-18261.appspot.com",
    messagingSenderId: "771513440744",
    appId: "1:771513440744:web:35b1bc0d1f52976dd8ac5d",
    measurementId: "G-1EPFZPCNXW"
  };
  
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

export const auth = firebase.auth();
export const db = firebase.firestore()


